export default "__VITE_ASSET__Dj8NO6bZ__"